import apis from '@/utils/apis';
// import qs from 'qs';

export default {
  methods: {
    closeOrderVisible(row) {
      const states = [20, 30, 40, 50, 60];
      return states.includes(row.caseOrderState);
    },
    /**
     * 导出工单
     * @param {object} formSearch 查询参数
     * @return {promise} promise
     */
    exportOrder(formSearch) {
      const postConfig = {
        api: apis.caseOrderPortalExport,
        label: '我的解决中'
      };

      const reqData = {
        ...formSearch
      };

      delete reqData.pageNum;
      delete reqData.pageSize;

      return this.$exportFlie(`${postConfig.api}`, reqData).catch(() => {
        this.$message.error('导出失败');
      });
    }
  }
};
